import _noop from "lodash/noop";
import _isInteger from "lodash/isInteger";
import _isString from "lodash/isString";
import _isBoolean from "lodash/isBoolean";
import _isPlainObject from "lodash/isPlainObject";
import { SignupForm } from '@datacamp/le-shared-components';
import { Dialog } from '@datacamp/waffles-modals';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isUser = obj => _isPlainObject(obj) && _isBoolean(obj.isLoggedIn) && _isString(obj.authenticationToken) && _isString(obj.email);
export const LoggedIn = _ref => {
  let {
    children,
    shouldBeLoggedIn = false,
    signupFormUrl,
    user
  } = _ref;
  if (isUser(user) && (shouldBeLoggedIn && user.isLoggedIn && _isInteger(user.id) || !shouldBeLoggedIn)) {
    return children({
      user
    });
  }
  return ___EmotionJSX(Dialog, {
    hideCloseButton: true,
    isOpen: true,
    onClose: _noop,
    width: 600
  }, ___EmotionJSX(SignupForm, {
    datacampUrl: signupFormUrl
  }));
};